import { authentication } from '@microsoft/teams-js';

/**
 * The token Teams itself hands out for the tab (the manifest's `webApplicationInfo`). Unlike MSAL's silent
 * sign-in it does not rely on the browser sending Microsoft cookies to the tab's iframe, which third-party
 * cookie blocking (InPrivate, strict tracking prevention, ...) prevents. Null when Teams has none to give
 * (no matching `webApplicationInfo` for this host, consent still needed, ...): the caller moves on to MSAL.
 * Silent, so no dialog opens on every page load.
 */
export async function getTeamsBrokeredToken(): Promise<string | null> {
    try {
        const token = (await authentication.getAuthToken({ silent: true }))?.trim();
        return token || null;
    } catch (error) {
        // Not fatal, but the reason (resourceDisabled, host not matching webApplicationInfo, consent, ...) is what
        // tells why the tab keeps depending on MSAL's cookie-based sign-in.
        console.warn('Teams getAuthToken unavailable, falling back to MSAL silent sign-in:', error);
        return null;
    }
}
